export const imgData = [
	{
		id: 1,
		src: "/images/Design-1.png",
		srcX2: "/images/Design-1@2x.png",
		title: "Cheese",
	},
	{
		id: 2,
		src: "/images/19.png",
		srcX2: "/images/19@2x.png",
		title: "Salad",
	},
	{
		id: 3,
		src: "/images/Design-2.png",
		srcX2: "/images/Design-2@2x.png",
		title: "Meat",
	},
	{
		id: 4,
		src: "/images/Design-3.png",
		srcX2: "/images/Design-3@2x.png",
		title: "Buns",
	},
	{
		id: 5,
		src: "/images/tomato.png",
		srcX2: "/images/tomato@2x.png",
		title: "Tomato",
	},
];
